module.exports = __webpack_public_path__ + "static/img/_MG_4577.ca19c61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_MG_4577.jpg
// module id = LLO0
// module chunks = 0